module.exports = __webpack_public_path__ + "static/lash_lift_hero_model_2-11d921e61242b66b68d4b2e769c04dfa.png";